import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

import { memo } from 'react';
import Text from '../../../../../../../react-components/Text';
import { TREE_ITEM_HEIGHT } from '../PlanOverviewListStyles';

const DriverStopsEmptyComponent = styled(Grid)`
  height: ${TREE_ITEM_HEIGHT - 1}px;
  background-color: transparent;
`;

interface DriverStopsEmptyPlaceholderProps {
  hideCompleted?: boolean;
}

export const DriverStopsEmptyPlaceholder = memo(({ hideCompleted = false }: DriverStopsEmptyPlaceholderProps) => {
  return (
    <Grid
      container
      style={{ backgroundColor: RoutalPalette.neutral05, padding: `0 8px`, height: `100%` }}
      alignItems="center"
      justifyContent="center"
    >
      <DriverStopsEmptyComponent container justifyContent="center" alignContent="center">
        <Text
          variant="label"
          intlId={hideCompleted ? `planoverview.route.no_pending_stops` : `planoverview.route.no_stops`}
          style={{ color: RoutalPalette.neutral20 }}
        />
      </DriverStopsEmptyComponent>
    </Grid>
  );
});
